import { CoeToDoWorkEntityModel } from "src/store/models/entity/coeToDoWork/entity";
import { CoeToDoWorkHelperModel } from "src/store/models/entity/coeToDoWork/helper";

export const encooCoeToDoWorkModels = {
  entity: CoeToDoWorkEntityModel,
  helper: CoeToDoWorkHelperModel,
};
